import React, {Component} from "react";

import {View, Text, TextInput}  from 'react-native';

import {estilos} from '../util/estilos'

import * as texto from '../util/texto'

import * as numeros from '../util/numeros'

import Botao from '../componentes/Botao'

import RotuloErro from '../componentes/RotuloErro'

import {EDR_TIPO_RESIDENCIAL, EDR_TIPO_COMERCIAL, EDR_TIPO_COBRANCA, UFs} from '../util/constantes'

import * as util from '../util/util'

import {MaskedTextInput} from "react-native-mask-text";

import {buscarCidades} from '../ws/ws_enderecos'

import Combo from '../componentes/Combo'

import Bloco from '../componentes/Bloco'



export default class FormularioEndereco extends Component {

	
	
	constructor(props) {
        
        super(props);
		
		this.state = {
			id: null,
			id_usuario: null,
			id_cidade: null,
			tipo: null,
			logradouro: null,
			numero: null,
			bairro: null,
			cep: null,
			referencia: null,
			complemento: null,
			uf: null,

			msgErro: null,
			editando: false	
        };
		
		this.btSalvarRef = React.createRef();
		this.cbCidadeRef = React.createRef();
    }
	
	
	setDados(id_usuario, endereco){
		
		this.setState({id_usuario: id_usuario});
		
		if(endereco!=null){
		
			this.setState({id: endereco.id});
			this.setState({tipo: endereco.tipo});
			this.setState({logradouro: endereco.logradouro});
			this.setState({numero: endereco.numero});
			this.setState({bairro: endereco.bairro});
			this.setState({cep: endereco.cep});
			this.setState({referencia: endereco.referencia});
			this.setState({complemento: endereco.complemento});
			this.setState({uf: endereco.uf});
		}
		else{
			
			this.setState({id: null});
			this.setState({tipo: null});
			this.setState({logradouro: null});
			this.setState({numero: null});
			this.setState({bairro: null});
			this.setState({cep: null});
			this.setState({referencia: null});
			this.setState({complemento: null});
			this.setState({uf: null});
			
			this.setState({editando: true});
		}	
    }
	
	
	validar(){
		
		this.btSalvarRef.current.setCarregando(true)
	
		const { salvar } = this.props;	

		if(this.state.tipo ==null){

            this.salvarErro("Selecione o tipo de Endereço.");
            return;
        } 
	
		if(texto.isBlanck(this.state.logradouro)){

            this.salvarErro("Informe o logradouro.");
            return;
        } 
		
		if(texto.isBlanck(this.state.bairro)){

            this.salvarErro("Informe o bairro.");
            return;
        } 
		
		if(texto.isBlanck(this.state.cep)){

            this.salvarErro("Informe o CEP.");
            return;
        } 
		
		let id_cidade = this.cbCidadeRef.current.getSelecionado();
		
		if(id_cidade==null){

            this.salvarErro("Selecione a cidade.");
            return;
        } 
		
		let numero = texto.isBlanck(this.state.numero)?"SN":this.state.numero;
		
		salvar({
			"id_cidade":id_cidade,
			"tipo":this.state.tipo,
			"logradouro":this.state.logradouro,
			"numero":numero,
			"bairro":this.state.bairro,
			"cep":numeros.formatarSomenteNum(this.state.cep),
			"referencia":this.state.referencia,
			"complemento":this.state.complemento
		});
	}

	
	salvarErro(mensagem){
		
        this.btSalvarRef.current.setCarregando(false);
		this.setState({msgErro: mensagem});
    }


	salvarSucesso(){
		
		this.btSalvarRef.current.setCarregando(false)
		this.setState({msgErro: null});
	}


	getTipos(){
		
		return [{"id": EDR_TIPO_RESIDENCIAL, "nome":"Residencial"}, 
					{"id": EDR_TIPO_COMERCIAL, "nome":"Comercial"},
						{"id": EDR_TIPO_COBRANCA, "nome":"Cobrança"}]
	}

	
	async mudouUf(id_uf_selecionada, id_cidade_selecionada=null){
		
		this.cbCidadeRef.current.setCarregando(true)

		let tem = false;
        
		if(util.temConteudo(id_uf_selecionada)){
		
			let lista = await buscarCidades(id_uf_selecionada);
		
			if(util.temConteudo(lista)){
				
				let selecionado = null;
				
				tem = true;
				
				if(id_cidade_selecionada!=null){
					for(var cidade of lista){
						if(cidade.id == id_cidade_selecionada){
							selecionado = cidade;
							break;
						}
					}
				}
				
				if(selecionado==null)
					this.cbCidadeRef.current.setDados(lista);
				else
					this.cbCidadeRef.current.setDadosComSelecionado(lista, selecionado);	
			}	
		}		
		
		if(!tem)
			this.cbCidadeRef.current.setDadosComSelecionado([], null)
		
		this.cbCidadeRef.current.setCarregando(false) 
	}


	formularioEditar(){
		
		return (
			<Bloco> 
				<View style={{marginTop:10}}/>  
						
				<View style={{alignItems:'center'}}>
					<Text style={estilos.rotulo_titulo}>Novo Endereço</Text>	    
				</View>
				
				<View style={{marginTop:10}}/>   
				
				<View style={estilos.grade}>
					<View style={[estilos.coluna]}>
						<Combo
							rotulo="Tipo:" 
							selecionado={null} 
							dados={this.getTipos()} 
							aoMudar={(valor)=>this.setState({tipo: valor.id})}/>
					</View>
					<View style={[estilos.coluna]}/>
				</View>
			
				<View style={{marginTop:10}}/>   
								 					
				<Text style={estilos.rotulo_padrao}>Logradouro:</Text>
	
				<TextInput
					placeholder=""
					style={estilos.campo_padrao} 
					multiline={false}
					onChangeText={(text)=>this.setState({logradouro: text})}
					maxLength={250}
					value={this.state.logradouro}/>
					
				<View style={{marginTop:10}}/> 
					
				<View style={estilos.grade}>
					<View style={[estilos.coluna]}>
						<Text style={estilos.rotulo_padrao}>Número:</Text>
	
						<TextInput
							placeholder=""
							style={estilos.campo_padrao} 
							multiline={false}
							onChangeText={(text)=>this.setState({numero: text})}
							maxLength={250}
							value={this.state.numero}/>
					</View>
					<View style={[estilos.coluna]}/>
				</View>
				
				<View style={{marginTop:10}}/>   
										
				<Text style={estilos.rotulo_padrao}>Bairro:</Text>
	
				<TextInput
					placeholder=""
					style={estilos.campo_padrao} 
					multiline={false}
					onChangeText={(text)=>this.setState({bairro: text})}
					maxLength={250}
					value={this.state.bairro}/>
				
				<View style={{marginTop:10}}/>   
				
				<View style={estilos.grade}>
					<View style={[estilos.coluna]}>
					
						<Text style={estilos.rotulo_padrao}>CEP:</Text>
	
						<MaskedTextInput  
								placeholder="" 
								mask="99999-999"
								style={estilos.campo_padrao} 
								onChangeText={(text, rawText)=>this.setState({cep: (rawText === ''?null:rawText)})}
								keyboardType="numeric"
								value={this.state.cep}/>
					</View>
					<View style={[estilos.coluna]}/>
				</View>	
				
				<View style={{marginTop:10}}/>   
				
				<View style={estilos.grade}>
					<View style={[estilos.coluna]}>
						<Combo 
							rotulo="UF:" 
							selecionado={null} 
							dados={UFs} 
							aoMudar={(valor)=>this.mudouUf(valor!=null?valor.id:null)} />		
					</View>
					<View style={[estilos.coluna]}/>
				</View>	
				
				<View style={{marginTop:10}}/>   
				
				<Combo 
					rotulo="Cidade:" 
					selecionado={null} 
					dados={[]} 
					ref={this.cbCidadeRef}/>
				
				<View style={{marginTop:10}}/>   
										
				<Text style={estilos.rotulo_padrao}>Referência (opcional):</Text>
	
				<TextInput
					placeholder=""
					style={estilos.campo_padrao} 
					multiline={false}
					onChangeText={(text)=>this.setState({referencia: text})}
					maxLength={250}
					value={this.state.referencia}/>
				
				<View style={{marginTop:10}}/>   
										
				<Text style={estilos.rotulo_padrao}>Complemento (opcional):</Text>
	
				<TextInput
					placeholder=""
					style={estilos.campo_padrao} 
					multiline={false}
					onChangeText={(text)=>this.setState({complemento: text})}
					maxLength={250}
					value={this.state.complemento}/>
				
				<View style={{alignItems:'center'}}>
					<RotuloErro mensagem={this.state.msgErro}/>
				</View>
					
				<View style={{alignItems:'center'}}>
					<Botao 
						acao={()=>this.validar()}
						texto={"Salvar Endereço"}
						ref={this.btSalvarRef}/>   
				</View>	
				
				<View style={{marginTop:10}}/>   		
			</Bloco>
		)
	}


	formularioVer(){

		return (
			<View style={[estilos.bloco, estilos.sombra, {flex:1, marginTop: 10, marginBottom: 10}]}> 
					
				<View style={{marginTop:10}}/>  
						
			</View>
		)	
	}
	
	
    render() {
		return (
			(this.state.editando)?
				(this.formularioEditar()):
				(this.formularioVer())
		)	
	}
} 
